import graphqlClient from '~/graphql/graphqlClient';

export interface MutationCopyHeroBuildArgs {
  playerId: string;
  heroHandle: string;
  heroBuildId: string;
  newBuildName: string;
}

export interface CopyHeroBuildResult {
  heroHandle: string;
  heroBuilds: any[];
}

const mutation = `
mutation CopyHeroBuild(
  $playerId: String!
  $heroHandle: String!
  $heroBuildId: String!
  $newBuildName: String!
) {
  copyHeroBuild(
    playerId: $playerId
    heroHandle: $heroHandle
    heroBuildId: $heroBuildId
    newBuildName: $newBuildName
  ) {
    heroHandle
    heroBuilds
  }
}`;

export default async function mutationCopyHeroBuild(args: MutationCopyHeroBuildArgs) {
  return await graphqlClient.request<CopyHeroBuildResult>('copyHeroBuild', mutation, args);
}
